/**
 * APP.TSX
 * Root file for react application
 * Setup routing
 */
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom"
import EndRoute from "@/routes/end.route"
import FaqRoute from "@/routes/faq.route"
import IntroRoute from "@/routes/intro.route"
import LoginRoute from "@/routes/login.route"
import NextRoute from "@/routes/next.route"
import QuestionsRoute from "@/routes/questions.route"
// QUICK PATCH : page de résultats désactivée (récapitulatif erroné)
// import ResultsRoute from "@/routes/results.route"
import CacheBuster from "react-cache-buster"
import pkg from "../package.json"
import FeedbackRoute from "@/routes/feedback.route"
import SurveyRoute from "./routes/survey.route"

function App() {
  return (
    <CacheBuster currentVersion={pkg} isEnabled>
      <Router>
        <Switch>
          <Route path="/end/:message">
            <EndRoute />
          </Route>
          <Route path="/faq">
            <FaqRoute />
          </Route>
          <Route path="/feedback/:id">
            <FeedbackRoute />
          </Route>
          <Route path="/intro">
            <IntroRoute />
          </Route>
          <Route path="/next">
            <NextRoute />
          </Route>
          <Route path="/questions">
            <QuestionsRoute />
          </Route>
          {/* QUICK PATCH : page de résultats désactivée (récapitulatif erroné) */}
          <Route path="/results">
            <Redirect to="/end/404" />
          </Route>
          <Route path="/survey/:id">
            <SurveyRoute />
          </Route>
          <Route path="/:code">
            <LoginRoute />
          </Route>
          <Route path="/">
            <LoginRoute />
          </Route>
          <Redirect to="/end/404" />
        </Switch>
      </Router>
    </CacheBuster>
  )
}

export default App
